export const AUTOSAVE_DEBOUNCE_MS = 1500;
export const TOAST_DURATION_MS = 3000;

export const MINIMAL_CHANGE_THRESHOLDS = {
  LOW_WC_BOUNDARY: 150,
  MEDIUM_WC_BOUNDARY: 250,
  LOW_WC: { wordDiff: 8, levPercent: 4 },
  MEDIUM_WC: { wordDiff: 5, levPercent: 3 },
  HIGH_WC: { wordDiff: 3, levPercent: 2 },
};

export const AI_TEMPERATURE = 1.0;
